import React from 'react';
import StrategyBuilder from './StrategyBuilder';
import StrategyBuilderErrorBoundary from './StrategyBuilderErrorBoundary';

const WrappedStrategyBuilder = () => (
  <StrategyBuilderErrorBoundary>
    <StrategyBuilder />
  </StrategyBuilderErrorBoundary>
);

export default WrappedStrategyBuilder;
